import ServiceTypeEnum from '@/app-core/api/enums/ServiceTypeEnum'

export default {
  name: 'DeliveryServiceCommon',

  computed: {
    deliveryServiceActive() {
      return this.AppDeliveryService?.Active ?? false
    },

    deliveryServiceCharge() {
      return this.AppDeliveryService?.Charge ?? null
    },

    deliveryServiceChargePrice() {
      return this.AppDeliveryService?.Charge?.Price ?? 0
    },

    deliveryServiceExtraFields() {
      return this.AppDeliveryService?.ExtraFields ?? null
    },

    deliveryServiceDeliveryAreas() {
      return this.deliveryServiceTypeIsGlobal ? this.AppDeliveryService?.Areas || [] : []
    },

    deliveryServiceHasDeliveryAreas() {
      return this.deliveryServiceTypeIsGlobal && this.deliveryServiceDeliveryAreas.length > 0
    },

    deliveryServiceTypeIsGlobal() {
      return this.AppConfig?.Marketplace?.DeliveryServiceType === ServiceTypeEnum.GLOBAL
    }
  },

  methods: {}
}
